export type ContextName = 'admin' | 'depots' | 'tenants' | 'services';

export const CONTEXT_CODES = {
  ADMIN: 'ADMIN',
  DEPOT: 'DEPOT',
  TENANT: 'TENANT',
  SERVICE: 'SERVICE'
} as const;

export type ContextCode = (typeof CONTEXT_CODES)[keyof typeof CONTEXT_CODES];

export interface Context {
  index: number;
  code: ContextCode;
  name: ContextName;
  svg: string;
  icon: string;
  path: string;
}
